module.exports = __webpack_public_path__ + "img/undraw_terms_re_6ak4 (1).82d2cba0.svg";